import HtmlViewerAPI from '@philips-emr/patient-components/src/components/html-viewer/html-viewer-api';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FragmentNames } from '../../codegen';
import { InstructionsAliases } from '../../codegen';
import ProfileBaseController from '../profile-base-controller';

@Controller({fragment: FragmentNames.INSTRUCTIONS})
export default class InstructionsController extends ProfileBaseController {

  @OnMount({target: InstructionsAliases.HTML_VIEWER_INSTRUCTIONS})
  handleMountInstructions(event: MountEvent):void{
    const htmlApi = event.target as HtmlViewerAPI;
    htmlApi.setHtmlContent(this.context.get('dsOrientacao') as string);
  }
}
